const numberWithCommas = (input: string): string => parseFloat(input).toLocaleString();

export default numberWithCommas;